<template>
  <div id="dashboard" style="padding-bottom:15px;">
    <div>
      <div class="container">
        <ul class="nav nav-tabs" style="padding-top:15px;">
          <li class="nav-item" :class="{'active' : currentView == 'statistic'}">
            <a class="nav-link" href="javascript:void(0);" @click="currentView = 'statistic'">
              <i class="fas fa-chart-bar"></i> Dashboard
            </a>
          </li>
          <li class="nav-item" :class="{'active' : currentView == 'crm'}">
            <a class="nav-link" href="javascript:void(0);" @click="currentView = 'crm'">
              <i class="fas fa-users"></i> Customers
            </a>
          </li>
          <li class="nav-item" v-if="false" :class="{'active' : currentView == 'custom_analytic'}">
            <a class="nav-link" href="javascript:void(0);" @click="currentView = 'custom_analytic'">
              <i class="fas fa-chart-line"></i> Custom Report
              <v-premium-lock :inline="true"></v-premium-lock>
            </a>
          </li>
        </ul>
        <div class="tab-container" v-if="currentView == 'statistic'">
          <br>
          <div class="container-fluid">
            <br>
            <div class="row">
              <div class="col-sm-6" style="margin-bottom: 15px;">
                <a
                  href="javascript:void(0)"
                  class="btn btn-none-radius"
                  :class="{'btn-primary': filter == 'all', 'btn-default': filter != 'all'}"
                  @click="filter = 'all';getData()"
                >All</a>
                <a
                  href="javascript:void(0)"
                  class="btn btn-none-radius"
                  :class="{'btn-primary': filter == 'facebook', 'btn-default': filter != 'facebook'}"
                  @click="filter = 'facebook';getData()"
                >
                  <i class="fab fa-facebook-square"></i> Facebook
                </a>
                <a
                  href="javascript:void(0)"
                  class="btn btn-none-radius"
                  :class="{'btn-primary': filter == 'line', 'btn-default': filter != 'line'}"
                  @click="filter = 'line';getData()"
                >
                  <i class="fab fa-line"></i> Line
                </a>
              </div>
              <div class="col-sm-6 text-right">
                <template v-if="loading">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-gray transparent disabled"
                    style="position:relative"
                  >
                    <pulse-loader :color="'#757575'" :size="'5px'"></pulse-loader>
                  </a>
                </template>
                <template v-else>
                  <a
                    href="javascript:void(0);"
                    v-if="$store.getters.getPackage != 'premium'"
                    class="btn btn-gray transparent disabled"
                    style="position:relative"
                    v-tooltip.top="'Unlock to PREMIUM plan'"
                  >
                    <span class="glyphicon glyphicon-export"></span> Export
                    <v-premium-lock></v-premium-lock>
                  </a>
                  <a
                    href="javascript:void(0);"
                    v-else-if="$store.getters.getPackage == 'premium'"
                    class="btn btn-gray transparent"
                    style="position:relative"
                    @click="exportDashboard"
                  >
                    <span class="glyphicon glyphicon-export"></span> Export
                  </a>
                </template>
              </div>
            </div>

            <div
              style="background: white;border-radius: 10px; border: 1px solid #eee;padding: 15px;margin-top: 10px;"
            >
              <div class="row">
                <div class="col-sm-12">
                  <span class="dashboard_datepicker">From:
                    <datepicker
                      v-model="selectedDate.start"
                      style="margin-bottom: 10px;"
                      @selected="onSelectedStartDate"
                    ></datepicker>
                  </span>
                  <span class="hidden-xs" style="margin: 0 10px">-</span>
                  <span class="dashboard_datepicker" style="margin-bottom: 10px;">To:
                    <datepicker v-model="selectedDate.end" style @selected="onSelectedEndDate"></datepicker>
                  </span>
                  <span class="hidden-xs" style="margin-right: 10px;"></span>
                  <div class="hidden-sm hidden-md hidden-lg"></div>
                  <a
                    href="javascript:void(0)"
                    class="btn btn-sm"
                    :class="{'btn-primary': currentFilter == 'today' , 'btn-default' : currentFilter != 'today' }"
                    style="margin-bottom: 5px;"
                    @click="changeDate('today')"
                  >Today</a>
                  <a
                    href="javascript:void(0)"
                    class="btn btn-sm"
                    :class="{'btn-primary': currentFilter == 'this_month' , 'btn-default' : currentFilter != 'this_month' }"
                    style="margin-bottom: 5px;"
                    @click="changeDate('this_month')"
                  >This Month</a>
                  <a
                    href="javascript:void(0)"
                    class="btn btn-sm"
                    :class="{'btn-primary': currentFilter == 'last_month' , 'btn-default' : currentFilter != 'last_month' }"
                    style="margin-bottom: 5px;"
                    @click="changeDate('last_month')"
                  >Last 30 Days</a>
                  <a
                    href="javascript:void(0)"
                    class="btn btn-sm"
                    :class="{'btn-primary': currentFilter == 'this_year' , 'btn-default' : currentFilter != 'this_year' }"
                    style="margin-bottom: 5px;"
                    @click="changeDate('this_year')"
                  >This Year</a>
                </div>
              </div>
            </div>

            <h3>Highlight</h3>
            <div class="row">
              <div class="col-sm-6">
                <div class="card">
                  <div class="header">Total Users</div>

                  <div class="body row" style="overflow: auto;">
                    <div class="col-sm-12" style="position:relative;">
                      <dashboard-graph-loading v-if="loadingTotalUserGraph"></dashboard-graph-loading>
                      <template v-if="totaluserSeries">
                        <apexchart
                          ref="totaluser"
                          type="pie"
                          height="350"
                          :options="totaluser"
                          :series="totaluserSeries"
                        ></apexchart>
                      </template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="row">
                  <div class="col-xs-12 col-sm-6">
                    <div class="card-stat">
                      Total Users
                      <span
                        style="color:#d4d4d4"
                        v-tooltip.top="'Number of users who talked with chatbot (All time)'"
                      >
                        <i class="fas fa-info-circle"></i>
                      </span>

                      <h3 class="stat">
                        <pulse-loader :color="$store.state.theme.brand_color" :size="'5px'" v-if="loadingAllStat"></pulse-loader>
                        <tween-num v-else
                          :value="parseInt(summary.totalusers)"
                          :initial="0"
                          :formatter="numberFormat"
                        ></tween-num>
                      </h3>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="card-stat">
                      No gender
                      <span
                        style="color:#d4d4d4"
                        v-tooltip.top="'Number of non-male and non-female users who talked with chatbot (All time)'"
                      >
                        <i class="fas fa-info-circle"></i>
                      </span>

                      <h3 class="stat">
                        <pulse-loader :color="$store.state.theme.brand_color" :size="'5px'" v-if="loadingAllStat"></pulse-loader>
                        <tween-num v-else
                          :value="parseInt(totaluserSeries[2])"
                          :initial="0"
                          :formatter="numberFormat"
                        ></tween-num>
                      </h3>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="card-stat">
                      Male
                      <span
                        style="color:#d4d4d4"
                        v-tooltip.top="'Number of male users who talked with chatbot (All time)'"
                      >
                        <i class="fas fa-info-circle"></i>
                      </span>

                      <h3 class="stat">
                        <pulse-loader :color="$store.state.theme.brand_color" :size="'5px'" v-if="loadingAllStat"></pulse-loader>
                        <tween-num v-else
                          :value="parseInt(totaluserSeries[0])"
                          :initial="0"
                          :formatter="numberFormat"
                        ></tween-num>
                      </h3>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="card-stat">
                      Female
                      <span
                        style="color:#d4d4d4"
                        v-tooltip.top="'Number of female users who talked with chatbot (All time)'"
                      >
                        <i class="fas fa-info-circle"></i>
                      </span>

                      <h3 class="stat">
                        <pulse-loader :color="$store.state.theme.brand_color" :size="'5px'" v-if="loadingAllStat"></pulse-loader>
                        <tween-num v-else
                          :value="parseInt(totaluserSeries[1])"
                          :initial="0"
                          :formatter="numberFormat"
                        ></tween-num>
                      </h3>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <hr>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="card-stat">
                      Active Users
                      <span
                        style="color:#d4d4d4"
                        v-tooltip.top="'Number of users who talked with chatbot during ' + dateFormat(selectedDate.start,'DD/MM/YYYY') + ' - ' + dateFormat(selectedDate.end,'DD/MM/YYYY')"
                      >
                        <i class="fas fa-info-circle"></i>
                      </span>

                      <h3 class="stat">
                        <pulse-loader :color="$store.state.theme.brand_color" :size="'5px'" v-if="loadingAllStat"></pulse-loader>
                        <tween-num v-else
                          :value="parseInt(summary.activeusers)"
                          :initial="0"
                          :formatter="numberFormat"
                        ></tween-num>
                      </h3>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="card-stat">
                      New Users
                      <span
                        style="color:#d4d4d4"
                        v-tooltip.top="'Number of new users who talked with chatbot during '+ dateFormat(selectedDate.start,'DD/MM/YYYY') + ' - ' + dateFormat(selectedDate.end,'DD/MM/YYYY')"
                      >
                        <i class="fas fa-info-circle"></i>
                      </span>

                      <h3 class="stat">
                        <pulse-loader :color="$store.state.theme.brand_color" :size="'5px'" v-if="loadingAllStat"></pulse-loader>
                        <tween-num v-else
                          :value="parseInt(summary.newusers)"
                          :initial="0"
                          :formatter="numberFormat"
                        ></tween-num>
                      </h3>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="card-stat">
                      Total Messages
                      <span
                        style="color:#d4d4d4"
                        v-tooltip.top="'Number of messages that chatbot had replied (All time)'"
                      >
                        <i class="fas fa-info-circle"></i>
                      </span>

                      <h3 class="stat">
                        <pulse-loader :color="$store.state.theme.brand_color" :size="'5px'" v-if="loadingAllStat"></pulse-loader>
                        <tween-num v-else
                          :value="parseInt(summary.totalmessages)"
                          :initial="0"
                          :formatter="numberFormat"
                        ></tween-num>
                      </h3>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="card-stat">
                      Active Messages
                      <span
                        style="color:#d4d4d4"
                        v-tooltip.top="'Number of messages that chatbot had replied during '+ dateFormat(selectedDate.start,'DD/MM/YYYY') + ' - ' + dateFormat(selectedDate.end,'DD/MM/YYYY')"
                      >
                        <i class="fas fa-info-circle"></i>
                      </span>

                      <h3 class="stat">
                        <pulse-loader :color="$store.state.theme.brand_color" :size="'5px'" v-if="loadingAllStat"></pulse-loader>
                        <tween-num v-else
                          :value="parseInt(summary.activemessages)"
                          :initial="0"
                          :formatter="numberFormat"
                        ></tween-num>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h3>Metrics</h3>
            <div class="row">
              <div class="col-sm-12">
                <div class="card">
                  <div class="header">Active Users by Date</div>

                  <div class="body row" style="overflow: auto;">
                    <div class="col-xs-12" style="overflow: hidden;position:relative">
                      <dashboard-graph-loading v-if="loadingActiveUserByDate"></dashboard-graph-loading>
                      <template v-if="activeuserbydateSeries">
                        <apexchart
                          ref="activeuserbydate"
                          type="area"
                          height="350"
                          :options="activeuserbydate"
                          :series="activeuserbydateSeries"
                        ></apexchart>
                      </template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="card">
                  <div class="header">Messages by Time</div>

                  <div class="body row" style="overflow: auto;">
                    <div class="col-xs-12" style="overflow: hidden;position:relative">
                      <dashboard-graph-loading v-if="loadingActiveUserByTime"></dashboard-graph-loading>
                      <div v-if="activeuserbytimeSeries">
                        <apexchart
                          ref="activeuserbytime"
                          type="area"
                          height="350"
                          :options="activeuserbytime"
                          :series="activeuserbytimeSeries"
                        ></apexchart>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="card">
                  <div class="header">Intents</div>

                  <div class="body row" style="position:relative;height: 350px">
                    <dashboard-graph-loading v-if="loadingAllIntent"></dashboard-graph-loading>
                    <!-- <div v-if="loadingIntent" class="text-center" style="padding-top: 35px; padding-bottom: 35px;">
                        <scale-loader :color="$store.state.theme.brand_color" height="35px" width="7px"></scale-loader>
                    </div>
                    <div v-else>-->
                    <template v-if="intentSeries && intentSeries.length > 0">
                      <div class="col-sm-5" style="border-right: 1px solid #eee;">
                        <apexchart
                          ref="intent"
                          type="pie"
                          height="350"
                          :options="intent"
                          :series="intentSeries"
                          style="margin: auto;"
                        ></apexchart>
                      </div>
                      <div class="col-sm-7">
                        <div style="max-height: 350px; overflow: auto;">
                          <div style="padding-top: 15px;padding-bottom: 15px;">
                            <template v-for="(intentItem,intentIndex) in intentSeries">
                              <template v-if="intent.labels[intentIndex] == 'default'">
                                <div
                                  :key="'intent_'+intentIndex"
                                  class="col-xs-12 col-sm-4 col-md-3 col-lg-3"
                                  :style="{'border-color' : '#cacaca'}"
                                  @click="openIntentDetail(intent.labels[intentIndex])"
                                  style="padding: 5px;"
                                >
                                  <div
                                    class=" intent-item-stat legend"
                                    style="border: 1px solid; padding: 15px;"
                                  >
                                    <div
                                      class="color-block"
                                      :style="{ background: intent.colors[intentIndex] }"
                                      style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                                    ></div>
                                    {{intent.labels[intentIndex] }}
                                    <h3 class="stat">{{ intentItem | numberFormat }}</h3>
                                  </div>
                                </div>
                              </template>
                              <template v-else>
                                <div
                                  class="col-xs-12 col-sm-4 col-md-3 col-lg-3"
                                  :style="{'border-color' : '#cacaca'}"
                                  :key="'intent_'+intentIndex"
                                  @click="openIntentDetail(intent.labels[intentIndex])"
                                  style="padding: 5px;"
                                >
                                  <div
                                    class=" intent-item-stat legend"
                                    :title="intent.labels[intentIndex]"
                                    style="border: 1px solid; padding: 15px;"
                                  >
                                    <div
                                      style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                                    >
                                      <div
                                        class="color-block"
                                        :style="{ background: intent.colors[intentIndex] }"
                                      ></div>
                                      {{intent.labels[intentIndex]}}
                                      <h3 class="stat">{{ intentItem | numberFormat }}</h3>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </template>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- </div> -->
                  </div>
                </div>
              </div>

              <modal-dialog v-if="showIntent && currentIntent" @close="showIntent = false">
                <span slot="header">{{currentIntent}}</span>

                <div slot="body">
                  <div v-if="loadingIntent">
                    <div style="padding: 30px 0">
                      <scale-loader
                        :color="$store.state.theme.brand_color"
                        height="45px"
                        width="7px"
                      ></scale-loader>
                    </div>
                  </div>
                  <div v-else-if="filterIntentDetail.length <= 0">
                    <div class="text-center" style="margin: 35px 0">
                      <img
                        src="/static/img/assets/setting/conversation.png"
                        alt
                        style="width: 230px"
                      >
                      <h3>Not found any chatlog</h3>
                      <!-- <p>test</p> -->
                    </div>
                  </div>
                  <div v-else>
                    <div class="text-center" style="margin-bottom: 10px;">
                      <router-link
                        :to="trainingUrl"
                        class="btn btn-primary"
                        v-if="currentIntent == 'default'"
                      >Go to Training Conversation</router-link>
                    </div>
                    <template v-if="filterIntentDetail">
                      <table class="tables" style="border-radius: 10px;width: 100%">
                        <thead>
                          <tr style="border: 1px solid #d8d6d6;border-bottom-width: 3px;">
                            <td
                              style="padding: 10px;width: 50%;border-right: 1px solid #d8d6d6;"
                            >Message</td>
                            <td style="padding: 10px;">Assigned to intent</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(intent, index) in filterIntentDetail"
                            :key="'intent_'+ index"
                            style="border: 1px solid #d8d6d6; padding: 15px; margin-bottom: 5px;overflow: auto; word-break: break-all;"
                          >
                            <td style="padding: 10px;border-right: 1px solid #d8d6d6;">
                              {{intent.questiondata ? intent.questiondata : '-'}}
                              <template v-if="intent.count > 1">({{intent.count}})</template>
                            </td>
                            <td style="padding: 10px;" class="text-center">
                              <template v-if="intent.newintent">{{intent.newintent}}</template>
                              <template v-else-if="!intent.newintent && intent.training == true">
                                <span style="font-style: italic; color: #d4d4d4">--- ignore ---</span>
                              </template>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                  </div>
                </div>

                <div slot="footer">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-default"
                    @click="showIntent = false"
                  >Close</a>
                  <router-link
                    :to="trainingUrl"
                    class="btn btn-primary"
                    v-if="currentIntent == 'default'"
                  >Training</router-link>
                </div>
              </modal-dialog>
            </div>
          </div>
        </div>

        <div class="tab-container" v-else-if="currentView == 'crm'">
          <br>
          <customers></customers>
        </div>

        <div class="tab-container" v-else-if="currentView == 'custom_analytic'">
          <div class="text-center" style="margin-bottom: 25px;">
            <img
              src="/static/img/assets/setting/premium_alert.png"
              alt
              style="width: 100%; max-width: 300px"
            >
            <h3>It's time to upgrade.</h3>
            <p>You have reached the limit of your current plan.</p>
            <router-link to="/setting?tab=billing" class="btn btn-primary">Upgrade your plan</router-link>
          </div>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/api";
import datepicker from "vuejs-datepicker";
import moment from "moment";
import numeral from "numeral";

import DateRangePicker from "@/components/elements/DateRangePicker";
// import TweenNumber from "@/components/elements/TweenNumber";

import ApexCharts from "apexcharts";
import VueApexCharts from "vue-apexcharts";

import TweenNum from "vue-tween-number";
import ModalDialog from "@/components/elements/ModalDialog";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Customers from "./Customers";

import DashboardGraphLoading from "./DashboardGraphLoading"

export default {
  data: function() {
    return {
      loadingTotalUserGraph: true,
      loadingAllStat: true,
      loadingActiveUserByDate: true,
      loadingActiveUserByTime: true,
      loadingAllIntent: true,
      loadingIntent: true,

      filter: "all",
      showIntent: false,
      currentView: "statistic",
      currentIntent: undefined,
      intentDetails: [],
      summary: {
        totalmessages: 0,
        activemessages: 0,
        activeusers: 0,
        totalusers: 0,
        newusers: 0
      },
      selectedDate: {
        start: moment()
          .startOf("month")
          .toDate(),
        end: moment()
          .endOf("month")
          .toDate()
      },

      currentFilter: "this_month",

      activeuserbydateChart: undefined,
      activeuserbytimeChart: undefined,
      totaluserChart: undefined,
      intentChart: undefined,

      activeuserbydateSeries: [],
      totaluserSeries: [0, 0, 0],
      intentSeries: [],
      activeuserbytimeSeries: [],

      activeuserbydate: {
        chart: {
          height: 350,
          type: "area"
        },
        stroke: {
          curve: "smooth"
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%"
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: "datetime"
        },
        yaxis: {
          title: {
            text: "Users"
          },
          tickAmount: 1
        },
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm"
          }
        }
      },
      activeuserbytime: {
        starttime: 0,
        endtime: 24,
        chart: {
          height: 350,
          type: "area",
          zoom: {
            enabled: true
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "straight"
        },
        xaxis: {
          categories: [
            "0:00",
            "1:00",
            "2:00",
            "3:00",
            "4:00",
            "5:00",
            "6:00",
            "7:00",
            "8:00",
            "9:00",
            "10:00",
            "11:00",
            "12:00",
            "13:00",
            "14:00",
            "15:00",
            "16:00",
            "17:00",
            "18:00",
            "19:00",
            "20:00",
            "21:00",
            "22:00",
            "23:00"
          ]
        },
        yaxis: {
          show: true,
          title: {
            text: "Messages"
          }
        },
        tooltip: {
          x: {
            format: "HH:mm"
          }
        }
      },
      totaluser: {
        chart: {
          type: "pie"
          // height: 350
        },
        labels: ["Male", "Female", "No gender"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                // width: 200
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      },
      intent: {
        chart: {
          type: "donut",
          height: 350
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                // width: 200
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: false
        }
      }
    };
  },
  components: {
    apexchart: VueApexCharts,
    datepicker,
    // TweenNumber,
    TweenNum,
    ModalDialog,
    ScaleLoader,
    Customers,
    PulseLoader,
    DashboardGraphLoading
  },
  created: function() {
    let vm = this;
    if (vm.$route.query.tab) {
      switch (vm.$route.query.tab) {
        case "statistic":
        case "crm":
        case "custom_analytic":
          vm.currentView = vm.$route.query.tab;
          break;
        default:
          vm.currentView = "statistic";
          break;
      }
    } else {
      vm.currentView = "statistic";
    }
  },
  mounted: function() {
    this.getData();
  },
  computed: {
    ...mapGetters({
      selectedBot: "selectedBot"
    }),
    loading: function() {
      var vm = this;
      return (
        vm.loadingTotalUserGraph &&
        vm.loadingAllStat &&
        vm.loadingActiveUserByDate &&
        vm.loadingActiveUserByTime &&
        vm.loadingAllIntent
      );
    },
    messageByTimeFiltered: function() {
      let vm = this;
      if (vm.activeuserbytime.starttime < vm.activeuserbytime.endtime) {
        if (vm.activeuserbytime.raw == null) {
          return null;
        }

        let label = [];
        let data = [];
        $.each(vm.activeuserbytime.raw, function(index, val) {
          if (
            vm.activeuserbytime.starttime <= val.index &&
            val.index <= vm.activeuserbytime.endtime
          ) {
            label.push(val.index + ":00");
            data.push(val.val);
          }
        });

        // return vm.fillActiveUserByDate(data, label);
      } else {
        let label = [];
        let data = [];
        $.each(vm.activeuserbytime.raw, function(index, val) {
          label.push(val.index + ":00");
          data.push(val.val);
        });

        // return vm.fillActiveUserByDate(data, label);
      }

      return null;
    },
    filterIntentDetail: function() {
      var vm = this;
      return vm.intentDetails.sort(function(a, b) {
        if (a.training == true && b.training != true) {
          return 1;
        }
        if (a.training != true && b.training == true) {
          return -1;
        }

        return 0;
      });
    },
    trainingUrl: function() {
      return (
        "/chatbot?tab=training&datefrom=" +
        moment(this.selectedDate.start).format("YYYY-MM-DD") +
        "&dateto=" +
        moment(this.selectedDate.end).format("YYYY-MM-DD")
      );
    }
  },
  methods: {
    numberFormat: function(val) {
      return numeral(val).format("0,0");
    },
    updateRoute: function() {
      this.$router.push({
        name: "dashboard",
        path: "/dashboard",
        query: {
          tab: this.currentView
        }
      });
      this.routeValue = JSON.stringify(this.$route.query);
    },
    onSelectedStartDate: function(value) {
      var vm = this;
      vm.currentFilter = "";
      if (moment(this.selectedDate.end).isBefore(value)) {
        this.selectedDate.end = value;
      }
      this.selectedDate.start = value;
      this.getData();
    },
    onSelectedEndDate: function(value) {
      var vm = this;
      vm.currentFilter = "";
      if (moment(value).isBefore(this.selectedDate.start)) {
        this.selectedDate.start = value;
      }
      this.selectedDate.end = value;
      this.getData();
    },
    onSelectedDate: function(value) {
      this.getData();
    },
    getData: function() {
      this.getSummary();
      this.getIntent();
      this.getActiveUserByDate();
      this.getActiveUserByTime();
    },
    getSummary: function() {
      let vm = this;
      let data = {
        pageid: this.selectedBot.pageid,
        datefrom: moment(this.selectedDate.start).format("YYYY-MM-DD"),
        dateto: moment(this.selectedDate.end).format("YYYY-MM-DD"),
        app: this.filter
      };
      vm.loadingTotalUserGraph = true;
      vm.loadingAllStat = true;
      api.getDashboardSummary(data, function(error, response) {
        if (error) {
          console.error(error);
          vm.loadingTotalUserGraph = false;
          vm.loadingAllStat = false;
          return;
        }
        if (response.data) {
          if (response.data.length > 0) {
            vm.summary.totalmessages = response.data[0].totalmessages;
            vm.summary.activemessages = response.data[0].activemessages;
            vm.summary.activeusers = response.data[0].activeusers;
            vm.summary.totalusers = response.data[0].totalusers;
            vm.summary.newusers = response.data[0].newusers;

            vm.totaluserSeries = [
              parseInt(response.data[0].totalusers_male),
              parseInt(response.data[0].totalusers_female),
              parseInt(response.data[0].totalusers_other)
            ];
          } else {
            vm.summary.totalmessages = 0;
            vm.summary.activemessages = 0;
            vm.summary.activeusers = 0;
            vm.summary.totalusers = 0;
            vm.summary.newusers = 0;

            vm.totaluserSeries = [0, 0, 0];
          }
        }
        vm.$nextTick(function() {
          vm.loadingTotalUserGraph = false;
          vm.loadingAllStat = false;
        });
      });
    },
    getIntent: function() {
      let vm = this;
      let data = {
        pageid: this.selectedBot.pageid,
        datefrom: moment(this.selectedDate.start).format("YYYY-MM-DD"),
        dateto: moment(this.selectedDate.end).format("YYYY-MM-DD"),
        app: this.filter
      };
      vm.loadingAllIntent = true;
      api.getDashboardIntent(data, function(error, response) {
        if (error) {
          console.error(error);
          vm.loadingAllIntent = false;
          return;
        }
        if (response.data) {
          let data = [];
          let label = [];
          let color = [];
          let sortedData = response.data.sort(vm.sortIntent);
          // console.log(sortedData)
          let default_data = null;
          $.each(sortedData, function(index, val) {
            // console.log(val,index)
            if (val["intent"] == "default") {
              label.unshift(val["intent"]);
              data.unshift(parseInt(val["count"]));
              color.unshift(vm.getRandomColor());
            } else {
              label.push(val["intent"] == null ? "Other" : val["intent"]);
              data.push(parseInt(val["count"]));
              color.push(vm.getRandomColor());
            }
          });
          vm.intentSeries = data;
          vm.intent.labels = label;
          vm.intent.colors = color;
          // vm.intentChart.updateOptions({
          // labels: label,
          // colors: color

          // });

          // vm.intentChart.updateSeries(vm.intentSeries);

          vm.$nextTick(function() {
            if (vm.$refs.intent) {
              vm.$refs.intent.updateOptions({
                colors: color,
                labels: label
              });
            }
            vm.loadingAllIntent = false;
          });
        }
      });
    },
    getActiveUserByDate: function() {
      let vm = this;
      let data = {
        pageid: this.selectedBot.pageid,
        datefrom: moment(this.selectedDate.start).format("YYYY-MM-DD"),
        dateto: moment(this.selectedDate.end).format("YYYY-MM-DD"),
        app: this.filter
      };
      vm.loadingActiveUserByDate = true;
      api.getDashboardActiveUserByDate(data, function(error, response) {
        if (error) {
          console.error(error);
          vm.loadingActiveUserByDate = false;
          return;
        }
        let data = [];
        let data2 = [];
        let label = [];

        let max = 0;

        $.each(response.data, function(index, val) {
          data.push([
            moment(val["date"]).format("YYYY-MM-DDT00:00:00"),
            parseInt(val["activeusers"])
          ]);
          data2.push([
            moment(val["date"]).format("YYYY-MM-DDT00:00:00"),
            parseInt(val["newusers"])
          ]);

          if (max < parseInt(val["activeusers"])) {
            max = parseInt(val["activeusers"]);
          }

          if (max < parseInt(val["newusers"])) {
            max = parseInt(val["newusers"]);
          }
        });

        vm.activeuserbydateSeries = [
          { name: "Active Users", data: data },
          { name: "New Users", data: data2 }
        ];

        vm.$nextTick(function() {
          if (vm.$refs.activeuserbydate) {
            vm.$refs.activeuserbydate.updateOptions({
              yaxis: {
                max: max + 5
              }
            });
          }
          vm.loadingActiveUserByDate = false;
        });
      });
    },
    getActiveUserByTime: function() {
      let vm = this;
      let data = {
        pageid: this.selectedBot.pageid,
        datefrom: moment(this.selectedDate.start).format("YYYY-MM-DD"),
        dateto: moment(this.selectedDate.end).format("YYYY-MM-DD"),
        time_0: vm.activeuserbytime.starttime,
        time_1: vm.activeuserbytime.endtime,
        app: this.filter
      };
      vm.loadingActiveUserByTime = true;
      api.getDashboardActiveUserByTime(data, function(error, response) {
        if (error) {
          console.error(error);
          vm.loadingActiveUserByTime = false;
          return;
        }
        let data = [];
        let label = [];
        let color = [];
        let max = 0;
        if (response.data.length > 0) {
          $.each(response.data[0], function(index, val) {
            label.push(index.split("_")[1] + ":00");
            data.push({ y: parseInt(val), x: index.split("_")[1] + ":00" });

            if (max < parseInt(val)) {
              max = parseInt(val);
            }
          });
          vm.activeuserbytime.raw = data;
        }

        vm.activeuserbytimeSeries = [{ name: "Messages", data: data }];

        // vm.activeuserbytime.xaxis.categories = label;
        vm.$nextTick(function() {
          if (vm.$refs.activeuserbytime) {
            vm.$refs.activeuserbytime.updateOptions({
              yaxis: {
                max: max + 5
              }
            });
          }
          vm.loadingActiveUserByTime = false;
        });
      });
    },
    getRandomColor: function() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    truncate: function(text, limit) {
      let length = text.length;
      return (
        text.substring(0, Math.min(limit, length)) +
        (length > limit ? "..." : "")
      );
    },
    sortIntent: function(a, b) {
      // console.log(a.count)
      if (parseInt(a.count) < parseInt(b.count)) return 1;
      if (parseInt(a.count) > parseInt(b.count)) return -1;
      return 0;
    },
    changeDate: function(value) {
      var vm = this;
      vm.currentFilter = value;
      switch (value) {
        case "today":
          vm.selectedDate.start = moment().toDate();
          vm.selectedDate.end = moment().toDate();
          break;

        case "last_month":
          vm.selectedDate.start = moment()
            .subtract(1, "months")
            .toDate();
          vm.selectedDate.end = moment().toDate();
          break;

        case "this_month":
          vm.selectedDate.start = moment()
            .startOf("month")
            .toDate();
          vm.selectedDate.end = moment()
            .endOf("month")
            .toDate();
          break;

        case "this_year":
          vm.selectedDate.start = moment()
            .startOf("year")
            .toDate();
          vm.selectedDate.end = moment()
            .endOf("year")
            .toDate();
          break;
      }
      vm.onSelectedDate();
    },
    getTrainingConversation: function() {
      var vm = this;
      var data = {
        pageid: vm.selectedBot.pageid,
        intentname: vm.currentIntent,

        datefrom: moment(this.selectedDate.start).format("YYYY-MM-DD"),
        dateto: moment(this.selectedDate.end).format("YYYY-MM-DD")
      };
      vm.loadingIntent = true;
      api.getTraningConversation(data, function(error, response) {
        if (error) {
          console.error(error);
          vm.loadingIntent = false;
          return;
        }

        var intentDetail = [];
        $.each(response.data, function(index, intent) {
          var isFound = false;
          if (intent.questiondata != null && intent.questiondata != "") {
            $.each(intentDetail, function(training_index, training_intent) {
              if (
                intent.id != training_intent.id &&
                intent.questiondata == training_intent.questiondata
              ) {
                isFound = true;
                intentDetail[training_index].count += 1;
                return;
              }
            });
            if (!isFound) {
              intent.count = 1;
              intentDetail.push(intent);
            }
          }
        });
        vm.intentDetails = intentDetail;
        vm.loadingIntent = false;
      });
    },
    openIntentDetail: function(intentName) {
      var vm = this;
      vm.currentIntent = intentName;
      vm.loadingIntent = true;
      vm.getTrainingConversation();
      vm.showIntent = true;
    },
    dateFormat: function(date, format) {
      return moment(date).format(format);
    },
    exportDashboard: function() {
      let vm = this;
      let csvContent = "";
      if (vm.loading) {
        return false;
      }

      csvContent +=
        'From,"' +
        moment(vm.selectedDate.start).format("DD/MM/YYYY") +
        '",To,"' +
        moment(vm.selectedDate.end).format("DD/MM/YYYY") +
        '"\r\n';
      csvContent += "\r\n";
      csvContent +=
        'Total Users,"' +
        numeral(vm.summary.totalusers).format("0,0") +
        '"\r\n';
      csvContent +=
        'No Gender Users,"' +
        numeral(parseInt(vm.totaluserSeries[2])).format("0,0") +
        '","' +
        numeral((vm.totaluserSeries[2] * 100) / vm.summary.totalusers).format(
          "0.0"
        ) +
        '%"\r\n';
      csvContent +=
        'Male Users,"' +
        numeral(parseInt(vm.totaluserSeries[0])).format("0,0") +
        '","' +
        numeral((vm.totaluserSeries[0] * 100) / vm.summary.totalusers).format(
          "0.0"
        ) +
        '%"\r\n';
      csvContent +=
        'Female Users,"' +
        numeral(parseInt(vm.totaluserSeries[1])).format("0,0") +
        '","' +
        numeral((vm.totaluserSeries[1] * 100) / vm.summary.totalusers).format(
          "0.0"
        ) +
        '%"\r\n';
      csvContent +=
        'Active Users,"' +
        numeral(vm.summary.activeusers).format("0,0") +
        '"\r\n';
      csvContent +=
        'New Users,"' + numeral(vm.summary.newusers).format("0,0") + '"\r\n';
      csvContent +=
        'Total Messages,"' +
        numeral(vm.summary.totalmessages).format("0,0") +
        '"\r\n';
      csvContent +=
        'Active Messages,"' +
        numeral(vm.summary.activemessages).format("0,0") +
        '"\r\n';
      csvContent += "\r\n";

      csvContent += "Active Users by Date\r\n";
      csvContent +=
        "Date," +
        vm.activeuserbydateSeries[0].name +
        "," +
        vm.activeuserbydateSeries[1].name +
        "\r\n";

      $.each(vm.activeuserbydateSeries[0].data, function(index, seriesData) {
        csvContent +=
          moment(seriesData[0]).format("DD/MM/YYYY") +
          ',"' +
          numeral(vm.activeuserbydateSeries[0].data[index][1]).format("0,0") +
          '","' +
          numeral(vm.activeuserbydateSeries[1].data[index][1]).format("0,0") +
          '"\r\n';
      });
      csvContent += "\r\n";
      csvContent += "Messages by Time\r\n";
      csvContent += "Time,Messages\r\n";

      $.each(vm.activeuserbytimeSeries[0].data, function(index, seriesData) {
        csvContent +=
          seriesData.y + ',"' + numeral(seriesData.x).format("0,0") + '"\r\n';
      });

      csvContent += "\r\n";
      csvContent += "Intents\r\n";
      csvContent += "Name,Count,Percent\r\n";

      var totalIntentMessage = 0;
      $.each(vm.intent.labels, function(index, seriesData) {
        totalIntentMessage += vm.intentSeries[index];
      });

      $.each(vm.intent.labels, function(index, seriesData) {
        csvContent +=
          seriesData +
          ',"' +
          numeral(vm.intentSeries[index]).format("0,0") +
          '","' +
          (totalIntentMessage > 0
            ? numeral(
                (vm.intentSeries[index] * 100) / totalIntentMessage
              ).format("0.0")
            : 0) +
          ' %"\r\n';
      });

      vm.exportCsv(csvContent, "crm");
    }
  },
  watch: {
    selectedBot: function(newVal, oldVal) {
      if (oldVal != newVal) {
        this.selectedDate = {
          start: moment()
            .subtract(1, "months")
            .toDate(),
          end: moment().toDate()
        };
        // this.$refs.rangeDatePicker.dateRange = {
        //   start: new Date(this.selectedDate.start),
        //   end: new Date(this.selectedDate.end)
        // };

        this.getData();
      }
    },
    currentView: function() {
      this.updateRoute();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/view/dashboard/Dashboard.vue